export default __webpack_public_path__ + "static/media/cameraDescriptionThumbnail.295b8349.svg";